<div class="base-container">
  <div *ngIf="showTitle">
    <h2>Usage Details</h2>
  </div>

  <ng-container *ngIf="isLoading; else dataContent">
    <div class="spinner-container">
      <div class="spinner"></div>
    </div>
  </ng-container>

  <ng-template #dataContent>
    <ng-container *ngIf="hasData && listData?.length > 0; else noDataTemplate">
      <h3>User Permissions</h3>
      <mat-accordion>
        <mat-expansion-panel
          *ngFor="let dataPoint of listData"
          [expanded]="isDataPointExpanded(dataPoint.PermissionType)"
          (opened)="toggleDataPointExpand(dataPoint.PermissionType)"
          (closed)="toggleDataPointExpand(dataPoint.PermissionType)"
        >
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ dataPoint.PermissionType }} | Number of Users:
              {{ dataPoint.UsageData.length }}</mat-panel-title
            >
          </mat-expansion-panel-header>

          <!-- User Search Bar -->
          <input
            type="text"
            placeholder="Search users..."
            [(ngModel)]="userSearch[dataPoint.PermissionType]"
            class="user-search"
          />

          <!-- Filtered Users -->
          <div
            *ngFor="
              let user of filterUsers(
                dataPoint.PermissionType,
                dataPoint.UsageData
              )
            "
          >
            <mat-expansion-panel
              [expanded]="isUserExpanded(dataPoint.PermissionType, user.UserId)"
              (opened)="toggleUserExpand(dataPoint.PermissionType, user.UserId)"
              (closed)="toggleUserExpand(dataPoint.PermissionType, user.UserId)"
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ user.FirstName }} {{ user.LastName }} ({{ user.UserName }})
                  | Total Sessions: {{ user.AppUsageSessions.length }}
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div *ngFor="let session of user.AppUsageSessions">
                <div style="margin-bottom: 10px">
                  Session: {{ session.SessionId }} | LoggedIn:
                  {{ session.LoggedIn }} | Total Session Time:
                  {{ session.TotalSessionTime | formatTime }} |
                  <button (click)="openModal(session)">
                    View Session Details
                  </button>
                </div>
              </div>
            </mat-expansion-panel>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-container>
  </ng-template>

  <ng-template #noDataTemplate>
    <p style="text-align: center">No data retrieved from server</p>
  </ng-template>

  <!-- Session Details Modal -->
  <ng-template #modalTemplate>
    <div class="modal-content">
      <div class="modal-header">
        <h2>{{ modalTitle }}</h2>
        <button class="close-button" (click)="closeModal()">X</button>
      </div>

      <div class="modal-body">
        <div *ngIf="modalData">
          <h3>Manuals Opened</h3>

          <ng-container
            *ngIf="modalData.ManualsOpened?.length > 0; else noManuals"
          >
            <mat-accordion>
              <mat-expansion-panel
                *ngFor="let manual of modalData.ManualsOpened"
                [expanded]="isVisible('doc', manual)"
                (opened)="toggleVisibility('doc', manual)"
                (closed)="toggleVisibility('doc', manual)"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    📄 {{ manual.Document?.FileName || "Unnamed Document" }}
                  </mat-panel-title>
                </mat-expansion-panel-header>

                <!-- Pages Viewed -->
                <div *ngIf="manual.PagesViewed && hasPagesViewed(manual)">
                  <p><strong>Pages Viewed:</strong></p>
                  <ul>
                    <li *ngFor="let page of getPagesViewed(manual.PagesViewed)">
                      Page {{ page.pageNumber }} - {{ page.count }} time(s)
                    </li>
                  </ul>
                </div>

                <!-- Search Terms Used -->
                <div *ngIf="manual.SearchTermsUsed && hasSearchTerms(manual)">
                  <p><strong>Search Terms Used:</strong></p>
                  <ul>
                    <li
                      *ngFor="
                        let term of getSearchTermsUsed(manual.SearchTermsUsed)
                      "
                    >
                      "{{ term.term }}" - {{ term.count }} times
                    </li>
                  </ul>
                </div>

                <!-- Dates Opened -->
                <div *ngIf="manual.DatesOpened?.length > 0">
                  <p><strong>Dates Opened:</strong></p>
                  <ul>
                    <ng-container *ngFor="let date of manual.DatesOpened">
                      <li *ngIf="date?.DateOpened">
                        {{ date.DateOpened }}
                      </li>
                    </ng-container>
                  </ul>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </ng-container>

          <ng-template #noManuals>
            <p>No manuals opened for this session.</p>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-template>
</div>
